import React from "react";

import Date from './props/Date';
import Description from './props/Description';
import Content from './props/Content';
import Image from './props/Image';
import Link from './props/Link';
import Title from './props/Title';

const None = ({
  date,
  description,
  content,
  image,
  link,
  properties,
  title
}) => {

  const isEnabled = name => !properties || properties.includes(name);

  const _image = isEnabled('image') ? `<img src="${image}" style="max-width: 100%" />` : '';
  const _title = isEnabled('title') ? title : '';
  const _date = isEnabled('date') ? date : '';
  const _description = isEnabled('description') ? description : '';
  const _content = isEnabled('content') ? content : '';
  const _link = isEnabled('link') ? link : '';

  const html = `
  ${_title}
  ${_link}
  ${_image}
  ${_date}
  ${_description}
  ${_content}
 `;

  return <div style={{ maxWidth: '100%' }} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default None;
